"use client";

import React, { useState } from "react";
import {
  btc, usdt, usdc, sol, card, complete, fast, instaghana, instakenya, instangn, instbtc, instsol, instusdc, instusdt, user1, user2, img, guard
} from "./images"
import Image from "next/image";
import { motion } from "motion/react"
import AnimatedFlowLine from "./AnimatedFlowLine";
import { ArrowDown, CircleDollarSign } from "lucide-react";


const Benefits = () => {
  const [isFirstCardHovered, setIsFirstCardHovered] = useState(false);
  const [isSecondCardHovered, setIsSecondCardHovered] = useState(false);
  const [isThirdCardHovered, setIsThirdCardHovered] = useState(false);
  const [isFourthCardHovered, setIsFourthCardHovered] = useState(false);
  const [isFifthCardHovered, setIsFifthCardHovered] = useState(false);

  return (
    <div className="max-w-[85rem] mx-auto pt-24 md:pt-40 px-4 font-inter">
      <div className="flex flex-col gap-2 md:gap-4 items-center text-center mb-8">
        <h2 className="font-semibold font-onest text-3xl md:text-4xl lg:text-5xl leading-[32px] md:leading-[40px] lg:leading-[48px] tracking-[0.35px] text-[#010721]">
          Your Crypto, Ready for Real Life
        </h2>
        <p className="font-normal text-sm md:text-base lg:text-lg tracking-[-0.44px] text-[#010721] w-full md:max-w-[29rem]">
          From wallet to bank. From screen to street. Spend your crypto with
          ease.
        </p>
      </div>

      <section className="w-full grid lg:grid-cols-3 md:grid-cols-2 gap-6">

        {/* first */}
        <div
          className="md:col-span-2 rounded-[16px] w-full flex flex-col items-start justify-between md:p-8 p-6"
          style={{
            backgroundColor: isFirstCardHovered ? "#EAFA35" : "#F4F4F4",
            transition: "background-color 0.2s ease-in-out 0.2s",
          }}
          onMouseEnter={() => setIsFirstCardHovered(true)}
          onMouseLeave={() => setIsFirstCardHovered(false)}
        >
          <div className="w-full md:pt-10 md:pb-20 py-4 md:px-8 px-8 relative">
            <AnimatedFlowLine isHovered={isFirstCardHovered} />

            {/* overlay  */}
            <div className="absolute inset-0 w-full h-full">
              <div className="relative w-full h-full">
                {/* btc */}
                <span className="absolute lg:left-0 md:-left-2 -left-3 top-[45px] size-[40px] sm:size-[52px] md:top-[60px] lg:top-[50px] md:size-[72px]">
                  <Image src={btc} alt="btc" className="w-full h-full object-contain" width={251} height={267} priority quality={100} />
                </span>

                {/* usdt */}
                <span className="absolute left-[15%] top-[50px] size-[36px] sm:top-[65px] sm:size-[48px] md:top-[80px] md:size-[68px]">
                  <Image src={usdt} alt="usdt" className="w-full h-full object-contain" width={237} height={254} priority quality={100} />
                </span>

                {/* usdc */}
                <span className="absolute left-[32%] top-[40px] size-[36px] sm:top-[52px] sm:size-[48px] md:top-[65px] md:size-[68px]">
                  <Image src={usdc} alt="usdc" className="w-full h-full object-contain" width={237} height={254} priority quality={100} />
                </span>

                {/* sol */}
                <span className="absolute left-[50%] top-[30px] size-[36px] sm:size-[48px] md:top-[25px] md:size-[68px]">
                  <Image src={sol} alt="sol" className="w-full h-full object-contain" width={237} height={254} priority quality={100} />
                </span>

                {/* card */}
                <span className="absolute md:right-0 -right-3 top-0 w-[120px] h-[75px] sm:w-[170px] sm:h-[105px] md:w-[230px] md:h-[140px]">
                  <Image src={card} alt="card" className="w-full h-full object-contain" width={725} height={469} priority quality={100} />
                </span>
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-1 ">
            <h3 className="font-semibold text-lg lg:text-xl tracking-[-0.45px] text-[#010721]">Spend Crypto Like Cash.</h3>
            <p className="font-normal text-sm md:text-base tracking-[-0.15px] text-[#6B7280]">Send crypto, receive directly into any bank account. No special setup needed.</p>
          </div>
        </div>

        {/* second  */}
        <div className="rounded-[16px] w-full flex flex-col md:p-8 p-6 items-start justify-between" style={{
          backgroundColor: isSecondCardHovered ? "#EAFA35" : "#F4F4F4",
          transition: "background-color 0.2s ease-in-out 0.2s",
        }}
          onMouseEnter={() => setIsSecondCardHovered(true)}
          onMouseLeave={() => setIsSecondCardHovered(false)}>
          <div className="w-full flex flex-col items-center relative">
            {/* Initiated */}
            <span className="bg-[#E8E8E8] px-[16px] py-[7px] text-center rounded-[8px] text-[#9BA5B0] font-inter text-[14px] -tracking-[0.4px] z-10">Initiated</span>

            {/* First arrow with diamond head */}
            <div className="h-[50px] relative flex items-center justify-center">
              <svg width="20" height="50" viewBox="0 0 20 50" fill="none" className="absolute">
                {/* Vertical line + diamond arrowhead pointing down */}
                <path d="M10,0 L10,30 L16,38 L10,48 L4,38 L10,30" stroke="#D1D5DB" strokeWidth="1.5" strokeLinejoin="round" fill="none" />
              </svg>
              <svg width="20" height="50" viewBox="0 0 20 50" fill="none" className="absolute">
                <motion.path
                  d="M10,0 L10,30 L16,38 L10,48 L4,38 L10,30"
                  stroke="#0095FF"
                  strokeWidth="1.5"
                  strokeLinejoin="round"
                  fill="none"
                  initial={{ pathLength: 0 }}
                  animate={{ pathLength: isSecondCardHovered ? 1 : 0 }}
                  transition={{ duration: 0.6, ease: "easeInOut" }}
                />
              </svg>
            </div>

            {/* Processing */}
            <span className="bg-[#E8E8E8] px-[16px] py-[7px] text-center rounded-[8px] text-[#9BA5B0] font-inter text-[14px] -tracking-[0.4px] z-10">Processing</span>

            {/* Second arrow with diamond head */}
            <div className="h-[50px] relative flex items-center justify-center">
              <svg width="20" height="50" viewBox="0 0 20 50" fill="none" className="absolute">
                {/* Vertical line + diamond arrowhead pointing down */}
                <path d="M10,0 L10,30 L16,38 L10,48 L4,38 L10,30" stroke="#D1D5DB" strokeWidth="1.5" strokeLinejoin="round" fill="none" />
              </svg>
              <svg width="20" height="50" viewBox="0 0 20 50" fill="none" className="absolute">
                <motion.path
                  d="M10,0 L10,30 L16,38 L10,48 L4,38 L10,30"
                  stroke="#0095FF"
                  strokeWidth="1.5"
                  strokeLinejoin="round"
                  fill="none"
                  initial={{ pathLength: 0 }}
                  animate={{ pathLength: isSecondCardHovered ? 1 : 0 }}
                  transition={{ duration: 0.6, ease: "easeInOut", delay: 0.4 }}
                />
              </svg>
            </div>

            {/* Completed */}
            <span className="relative inline-block w-[124px] h-[42px] z-10">
              <Image src={complete} alt="complete" className="w-full h-full" width={396} height={126} quality={100} priority />

              <motion.span
                className="absolute -right-14 -top-7 inline-block w-[100px]"
                initial={{ scale: 1 }}
                animate={{ scale: isSecondCardHovered ? [1, 1.2] : 1 }}
                transition={{
                  repeat: isSecondCardHovered ? Infinity : 0,
                  repeatType: "mirror",
                  delay: 0.5,
                  duration: 0.5,
                }}
              >
                <Image src={fast} alt="fast" className="w-full h-full" width={292} height={210} quality={100} priority />
              </motion.span>
            </span>
          </div>

          <div className="flex flex-col gap-1 mt-6">
            <h3 className="font-semibold text-lg lg:text-xl tracking-[-0.45px] text-[#010721]">No Crypto Headaches.</h3>
            <p className="font-normal text-sm md:text-base tracking-[-0.15px] text-[#6B7280]">No charts. No jargon. Just send crypto and receive cash like a normal transfer.</p>
          </div>
        </div>

        {/* third Card */}
        <div className="rounded-[16px] w-full flex flex-col gap-5 lg:gap-0 lg:p-8 p-6 items-start justify-between" style={{
          backgroundColor: isThirdCardHovered ? "#EAFA35" : "#F4F4F4",
          transition: "background-color 0.2s ease-in-out 0.2s",
        }}
          onMouseEnter={() => setIsThirdCardHovered(true)}
          onMouseLeave={() => setIsThirdCardHovered(false)}>

          <div className="w-full flex flex-col h-[233px] px-6 justify-center items-center relative">
            {/* card of stables */}
            <div className="w-auto -ml-14 relative">
              <div className="w-[188px] h-[64px] border-[4px] flex flex-col px-2 py-1 gap-1.5 bg-[#D5F0FF] rounded-[8px]"
                style={{
                  borderColor: isThirdCardHovered ? "#0095FF" : "#E0E0E0",
                  transition: "0.8s ease-in-out 0.5s"
                }}
              >
                <div className="w-full grid grid-cols-4 gap-2">
                  <Image src={instusdt} alt="usdt" className="max-w-[32px]" width={96} height={96} priority quality={100} />
                  <Image src={instusdc} alt="usdc" className="max-w-[32px]" width={96} height={96} priority quality={100} />
                  <Image src={instbtc} alt="btc" className="max-w-[32px]" width={96} height={96} priority quality={100} />
                  <Image src={instsol} alt="sol" className="max-w-[32px]" width={96} height={96} priority quality={100} />
                </div>
                <div className="w-full flex flex-col gap-1">
                  <div className={`${isThirdCardHovered ? "bg-[#0095FF]" : "bg-[#00B7FF66]"} ml-2 w-[50%] h-[2px] rounded-[32px]`} style={{ transition: "background-color 0.8s ease-in-out 0.5s" }} />
                  <div className={`${isThirdCardHovered ? "bg-[#0095FF]" : "bg-[#00B7FF66]"} ml-2 w-[30%] h-[2px] rounded-[32px]`} style={{ transition: "background-color 0.8s ease-in-out 0.5s" }} />
                </div>
              </div>

              {/* fiats */}
              <div className="absolute -bottom-[55%] lg:-right-[32%] -right-[15%] bg-[#F9FDFF] w-[144px] h-[48px] border-dashed rounded-[8px] border-[1.5px] grid grid-cols-3 gap-2 px-2 py-[7px]"
                style={{
                  borderColor: isThirdCardHovered ? "#0095FF" : "#E0E0E0",
                  transition: "0.8s ease-in-out 0.5s"
                }}>
                <Image src={instangn} alt="NGN" className="max-w-[32px]" width={96} height={96} priority quality={100} />
                <Image src={instaghana} alt="ghana" className="max-w-[32px]" width={96} height={96} priority quality={100} />
                <Image src={instakenya} alt="kenya" className="max-w-[32px]" width={96} height={96} priority quality={100} />
              </div>
            </div>

            {/*  personas - users */}
            <span className="absolute lg:-bottom-3 bottom-0 lg:left-[15%] left-[10%] inline-block size-[60px] z-10">
              <Image src={user1} alt="user" className="w-full h-full" width={180} height={180} priority quality={100} />
            </span>

            <span className="absolute top-[27%] lg:right-[3%] right-[6%] inline-block size-[60px] z-10">
              <Image src={user2} alt="user" className="w-full h-full" width={180} height={180} priority quality={100} />
            </span>

            {/* Dashed SVG lines connecting users to cards */}
            <svg
              className="absolute lg:inset-0 -left-[14px] w-full h-full pointer-events-none"
              viewBox="0 0 320 200"
              fill="none"
            >
              {/* Line 1: User1 to Crypto Card - bracket shape [ */}
              {/* Bottom stub → vertical up → top stub */}
              <path
                d="M51.5,187.5 L35.5,187.5 L35.5,103.5 L51.5,103.5"
                stroke="#E0E0E0"
                strokeWidth="1.5"
                strokeDasharray="2 2"
                strokeLinecap="round"
                fill="none"
              />
              <motion.path
                d="M51.5,187.5 L35.5,187.5 L35.5,103.5 L51.5,103.5"
                stroke="#0095FF"
                strokeWidth="1.5"
                strokeDasharray="2 2"
                strokeLinecap="round"
                fill="none"
                initial={{ pathLength: 0 }}
                animate={{ pathLength: isThirdCardHovered ? 1 : 0 }}
                transition={{ duration: 0.8, ease: "easeInOut" }}
              />

              {/* Line 2: User2 to Fiat Card - L shape */}
              {/* Vertical down → horizontal left */}
              <path
                d="M284.5,106.5 L284.5,141.5 L271.5,141.5"
                stroke="#E0E0E0"
                strokeWidth="1.5"
                strokeDasharray="2 2"
                strokeLinecap="round"
                fill="none"
              />
              <motion.path
                d="M284.5,106.5 L284.5,141.5 L271.5,141.5"
                stroke="#0095FF"
                strokeWidth="1.5"
                strokeDasharray="2 2"
                strokeLinecap="round"
                fill="none"
                initial={{ pathLength: 0 }}
                animate={{ pathLength: isThirdCardHovered ? 1 : 0 }}
                transition={{ duration: 0.8, ease: "easeInOut", delay: 0.3 }}
              />
            </svg>
          </div>

          <div className="flex flex-col gap-1">
            <h3 className="font-semibold text-lg lg:text-xl tracking-[-0.45px] text-[#010721]">Instant Settlement</h3>
            <p className="font-normal text-sm md:text-base tracking-[-0.15px] text-[#6B7280]">Convert crypto to cash in just a few steps. Once sent, your bank gets credited immediately.</p>
          </div>
        </div>

        {/* Fourth Card */}
        <div className="rounded-[16px] w-full flex flex-col md:p-8 p-6 items-start justify-between" style={{
          backgroundColor: isFourthCardHovered ? "#EAFA35" : "#F4F4F4",
          transition: "background-color 0.2s ease-in-out 0.2s",
        }}
          onMouseEnter={() => setIsFourthCardHovered(true)}
          onMouseLeave={() => setIsFourthCardHovered(false)}>

          <div className="w-full h-[233px] flex flex-col items-start justify-start relative">
            {/* Card */}
            <div className={`w-[275px] h-[65px] absolute z-20 bottom-0 left-0 rotate-[4deg] border-[4px] p-[6px] rounded-[8px] flex flex-row justify-between bg-[#E2FFD5] items-center`} style={{
              borderColor: isFourthCardHovered ? "#53fc5b" : "#B0FFB4",
              transition: "border-color 0.4s ease-in-out 0.4s",
            }}>
              <div className="flex justify-start items-end gap-0.5">
                <div className="size-[38px] bg-[#9EFBB8] text-[#00A713] transform flex justify-center items-center rounded-[4px]">
                  <ArrowDown className={`size-[22px] relative ${isFourthCardHovered ? "rotate-[630deg] animate-pulse ease-in-out duration-500" : "ease-in-out duration-500"}`} />
                </div>
                <div className="flex flex-col gap-2 w-[78px] mb-1">
                  <div className={`${isFourthCardHovered ? "bg-[#00ff22a3]" : "bg-[#00FF2266]"} ml-2 w-[100%] h-[2px] rounded-[32px]`} style={{ transition: "background-color 0.8s ease-in-out 0.5s" }} />
                  <div className={`${isFourthCardHovered ? "bg-[#00ff22a3]" : "bg-[#00FF2266]"} ml-2 w-[50%] h-[2px] rounded-[32px]`} style={{ transition: "background-color 0.8s ease-in-out 0.5s" }} />
                </div>
              </div>
              <span className={`font-inter text-[10px] -tracking-[0.45px] mb-4 pr-3 font-medium duration-500 ease-in-out ${isFourthCardHovered ? "text-[#00770E]" : "text-[#00770E]/60"} `}>Convert and receive fiat</span>
            </div>

            {/* Card */}
            <div className={`w-[275px] h-[65px] absolute z-10 bottom-[60px] right-0  border-[4px] p-[6px] rounded-[8px] flex flex-row justify-between bg-[#D5F0FF] items-center`} style={{
              borderColor: isFourthCardHovered ? "#41b0ff" : "#88CDFF",
              transition: "border-color 0.4s ease-in-out 0.4s",
            }}>
              <div className="flex flex-col w-[40%] justify-center items-end">
                <div className="flex flex-col w-full justify-start items-start gap-1.5">
                  <div className={`${isFourthCardHovered ? "bg-[#00b7ffd2]" : "bg-[#00B7FF66]"} w-[100%] h-[2px] rounded-[32px]`} style={{ transition: "background-color 0.8s ease-in-out 0.5s" }} />
                  <div className={`${isFourthCardHovered ? "bg-[#00b7ffd2]" : "bg-[#00B7FF66]"} w-[50%] h-[2px] rounded-[32px]`} style={{ transition: "background-color 0.8s ease-in-out 0.5s" }} />
                </div>
                <CircleDollarSign strokeWidth={0.75} className={`size-[30px] text-[#00B7FF] ${isFourthCardHovered ? "animate-bounce" : ""}`} />
              </div>
              <span className={`font-inter text-[10px] -tracking-[0.45px] mb-4 pr-3 font-medium duration-500 ease-in-out ${isFourthCardHovered ? "text-[#0097D7]" : "text-[#0097D7]/60"} `}>Favourable market rates</span>
            </div>

            {/* Card  */}
            <div className={`w-[275px] h-[65px] absolute z-0 bottom-[120px] left-0 -rotate-[8deg] border-[4px] p-[6px] rounded-[8px] flex flex-row justify-between bg-[#FFD5F7] items-center`} style={{
              borderColor: isFourthCardHovered ? "#fa5dc6" : "#FFA9E2",
              transition: "border-color 0.4s ease-in-out 0.4s",
            }}>
              <div className="flex gap-3 w-[45%] justify-end items-center">
                <motion.div className="size-[38px]"
                  initial={{ scale: 1 }}
                  animate={{ scale: isFourthCardHovered ? [1, 1.2] : 1 }}
                  transition={{
                    repeat: isFourthCardHovered ? Infinity : 0,
                    repeatType: "mirror",
                    delay: 0.5,
                    duration: 0.5,
                  }}>
                  <Image src={img} alt="user_image" className="w-full h-full object-contain" width={153} height={153} quality={100} priority />
                </motion.div>
                <span className={`font-inter text-[11px] -tracking-[0.45px] font-medium duration-500 ease-in-out ${isFourthCardHovered ? "text-[#F910BF]" : "text-[#F910BF]/60"} `}>Get started</span>

              </div>
              <div className="flex flex-col w-[45%] justify-start items-end gap-2">
                <div className={`${isFourthCardHovered ? "bg-[#ffa9e2fe]" : "bg-[#FFA9E266]"} w-[100%] h-[2px] rounded-[32px]`} style={{ transition: "background-color 0.8s ease-in-out 0.5s" }} />
                <div className={`${isFourthCardHovered ? "bg-[#ffa9e2fe]" : "bg-[#FFA9E266]"} w-[50%] h-[2px] rounded-[32px]`} style={{ transition: "background-color 0.8s ease-in-out 0.5s" }} />
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-1 mt-6">
            <h3 className="font-semibold text-lg lg:text-xl text-left tracking-[-0.45px] text-[#010721]">Clear Rates. Always.</h3>
            <p className="font-normal text-sm md:text-base text-left tracking-[-0.15px] text-[#6B7280]">No confusing calculations or hidden charges.</p>
          </div>
        </div>

        {/* Fifth Card */}
        <div className="rounded-[16px] w-full flex flex-col md:p-8 p-6 items-center justify-start" style={{
          backgroundColor: isFifthCardHovered ? "#EAFA35" : "#F4F4F4",
          transition: "background-color 0.2s ease-in-out 0.2s",
        }}
          onMouseEnter={() => setIsFifthCardHovered(true)}
          onMouseLeave={() => setIsFifthCardHovered(false)}>

          <div className="w-full h-[233px] flex flex-col items-center justify-center relative">
            <div className="w-[204px] flex flex-col items-center -space-y-2 relative">
              {/* 1 */}
              <motion.div
                className="w-full h-[29px] z-0 rounded-[8px] bg-[#E5F6FF] relative"
                animate={{ y: isFifthCardHovered ? [0, -10] : 0 }}
                transition={{
                  repeat: isFifthCardHovered ? Infinity : 0,
                  repeatType: "mirror",
                  duration: 0.5,
                  delay: 0
                }}
              />
              {/* 2 */}
              <motion.div
                className="w-[188px] h-[29px] z-[2] rounded-[8px] bg-[#D5F0FF] relative"
                animate={{ y: isFifthCardHovered ? [0, -5] : 0 }}
                transition={{
                  repeat: isFifthCardHovered ? Infinity : 0,
                  repeatType: "mirror",
                  duration: 0.5,
                  delay: 0.05
                }}
              />
              {/* 3 */}
              <motion.div
                className="w-[172px] h-[29px] z-[4] rounded-[8px] bg-[#A7DFFF] relative"
                animate={{ y: isFifthCardHovered ? 0 : 0 }}
                transition={{
                  repeat: isFifthCardHovered ? Infinity : 0,
                  repeatType: "mirror",
                  duration: 0.5,
                  delay: 0.1
                }}
              />
              {/* 4 */}
              <motion.div
                className="w-[156px] h-[29px] z-[6] rounded-[8px] bg-[#90D6FF] relative"
                animate={{ y: isFifthCardHovered ? [0, 5] : 0 }}
                transition={{
                  repeat: isFifthCardHovered ? Infinity : 0,
                  repeatType: "mirror",
                  duration: 0.5,
                  delay: 0.15
                }}
              />
              {/* 5 */}
              <motion.div
                className="w-[140px] h-[29px] z-[8] rounded-[8px] bg-[#6BC9FF] relative"
                animate={{ y: isFifthCardHovered ? [0, 10] : 0 }}
                transition={{
                  repeat: isFifthCardHovered ? Infinity : 0,
                  repeatType: "mirror",
                  duration: 0.5,
                  delay: 0.2
                }}
              />
              {/* 6 */}
              <motion.div
                className="w-[124px] h-[29px] z-[10] rounded-[8px] bg-[#53C0FF] relative"
                animate={{ y: isFifthCardHovered ? [0, 15] : 0 }}
                transition={{
                  repeat: isFifthCardHovered ? Infinity : 0,
                  repeatType: "mirror",
                  duration: 0.5,
                  delay: 0.25
                }}
              />
              {/* 7 */}
              <motion.div
                className="w-[108px] h-[29px] z-[12] rounded-[8px] bg-[#36B5FF] relative"
                animate={{ y: isFifthCardHovered ? [0, 20] : 0 }}
                transition={{
                  repeat: isFifthCardHovered ? Infinity : 0,
                  repeatType: "mirror",
                  duration: 0.5,
                  delay: 0.3
                }}
              />
              {/* 8 */}
              <motion.div
                className="w-[92px] h-[29px] z-[14] rounded-[8px] bg-[#21AEFF] relative"
                animate={{ y: isFifthCardHovered ? [0, 25] : 0 }}
                transition={{
                  repeat: isFifthCardHovered ? Infinity : 0,
                  repeatType: "mirror",
                  duration: 0.5,
                  delay: 0.35
                }}
              />

              {/* overlay */}
              <motion.div
                className="size-[56px] absolute z-[16] bottom-[18%]"
                initial={{ scale: 1 }}
                animate={{ scale: isFifthCardHovered ? [1, 1.1] : 1 }}
                transition={{
                  repeat: isFifthCardHovered ? Infinity : 0,
                  repeatType: "mirror",
                  delay: 0.5,
                  duration: 0.5,
                }}
              >
                <Image src={guard} className="w-full h-full object-contain" alt="guard" width={235} height={235} quality={100} priority />
              </motion.div>
            </div>
          </div>

          <div className="flex flex-col gap-1 mt-6">
            <h3 className="font-semibold text-lg lg:text-xl tracking-[-0.45px] text-[#010721]">Built to Be Trusted</h3>
            <p className="font-normal text-sm md:text-base tracking-[-0.15px] text-[#6B7280]">We only convert. We don&apos;t hold funds. Your crypto moves, your bank receives - safely and instantly.</p>
          </div>
        </div>

      </section >
    </div >
  );
};

export default Benefits;
